import React, { useState, useEffect } from 'react';
import HelpTogal from '../TogelButton/HelpTogal';
import InventoryServices from '../../services/InventoryServices';
import CottageServices from '../../services/CottageServices';

function UpdateInventory({ room, closeModal, onSuccess }) {
    const [cottage, setCottage] = useState([]);
    const [formValues, setFormValues] = useState({
        cottage: "",
        roomNumber: "",
        roomType: null, // Initialize as null instead of an empty string
        description: "",
        status: "",
    });

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
            return ''; // Return an empty string for invalid dates
        }
        const year = date.getFullYear().toString();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    useEffect(() => {
        if (room) {
            setFormValues({
                cottage: room?.cottage?.id || '',
                description: room?.description || '',
                roomNumber: room?.roomNumber || '',
                roomType: room?.roomType || '',
                status: room?.status || '',
            });

        }
    }, [room]);
    useEffect(() => {
        const fetchCottage = async () => {
            try {
                const res = await CottageServices.getCottage();
                if (res.status) {
                    setCottage(res.data);
                } else {
                    alert('Failed to fetch Cottage');
                }
            } catch (error) {
                console.error('Error fetching Cottage', error);
                alert('Failed to fetch Cottage');
            }
        };
        fetchCottage();
    }, []);
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormValues({
            ...formValues,
            [name]: value,
        });
    };



    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            const formData = new FormData();
            for (const key in formValues) {
                if (key !== 'image' || formValues[key] instanceof File) {
                    formData.append(key, formValues[key]);
                }
            }

            await InventoryServices.updateInventory(room.id, formValues);
            alert('Inventory updated successfully');
            onSuccess();
            closeModal();
        } catch (error) {
            console.error('Failed to update Inventory', error);
            alert(error.response.data.message || 'Failed to update Inventory');
        }
    };

    return (
        <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title"> Edit Inventory</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
                    </div>
                    <div className="modal-body">
                        <div className="container-box px-5">
                            <div className="container-box-inner">
                                <div className="page-details">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6">
                                                <div className="input-field">
                                                    <label> Cottage Name</label>
                                                    <select className="form-select" name="cottage" value={formValues.cottage} onChange={handleInputChange}>
                                                        <option value="">Select  Cottage</option>
                                                        {cottage.map((cot) => (
                                                            <option key={cot._id} value={cot._id}>
                                                                {cot.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="input-field">
                                                    <label>Cottage Number</label>
                                                    <input
                                                        type="text"
                                                        name="roomNumber"
                                                        className="form-control"
                                                        value={formValues.roomNumber}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter Cottage Number"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="input-field">
                                                    <label>Room Type</label>
                                                    <select className="form-select" name="roomType" value={formValues.roomType} onChange={handleInputChange}>
                                                        <option selected="">Select Room Type</option>
                                                        <option value="Single">Single</option>
                                                        <option value="Double">Double</option>
                                                        <option value="Suite">Suite</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="input-field">
                                                    <label>Cottage Status</label>
                                                    <select className="form-select" name="status" value={formValues.status} onChange={handleInputChange}>
                                                        <option selected="">Select Room Status</option>
                                                        <option value="Available">Available</option>
                                                        <option value="Booked">Booked</option>
                                                        <option value="Maintenance">Maintenance</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-12 col-md-12">
                                                <div className="input-field">
                                                    <label>Room Description</label>
                                                    <textarea
                                                        type="text"
                                                        name="description"
                                                        className="form-control"
                                                        value={formValues.description}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter Room Description"
                                                        required
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                        <button className="site-btn-green">Update</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UpdateInventory;
